
import { defineComponent, ref, Ref } from 'vue'
import { Map, VectorLayer, Marker, Coordinate } from 'maptalks'
import AppHeader from '@/components/Header.vue'
import DeviceFooter from '@/components/device/Footer.vue'
import getMapSiteInfo from '@/compositions/map/index'
import { Popup, Search, Toast } from 'vant'
import { NetworkpointItem, CacheFaultBill } from '@/types/fault'
import { useStore } from 'vuex'
import { getMap } from '@/utils/maptalkFactory'
import { copy } from '@/utils/index'
import getCacheFaultBillInfo from '@/compositions/fault/device'

interface DrawElement {
  lat: number
  lng: number
  name: string
}
export default defineComponent({
  name: 'Fault-Networkpoints',
  components: {
    AppHeader,
    DeviceFooter,
    VanPopup: Popup,
    VanSearch: Search,
  },
  setup() {
    const store = useStore()
    const box = ref<HTMLElement>()
    const keywords: Ref<string> = ref('')
    let _selectedItem: NetworkpointItem
    const rightCanClick: Ref<boolean> = ref(false)
    const { cacheFaultBill, cacheNetworkpoint } = getCacheFaultBillInfo()
    let { mapSite, mapZoom, mapCenter } = getMapSiteInfo()
    let _layer: VectorLayer = null
    let map: Map = null
    const show = ref(true)
    const pHeight = ref('58%')
    return {
      pHeight,
      show,
      $store: store,
      isMiniProgram: store.getters.isMiniProgram,
      mapSite,
      mapZoom,
      mapCenter,
      map,
      box,
      _layer,
      keywords,
      _selectedItem,
      cacheNetworkpoint,
      rightCanClick,
      cacheFaultBill,
    }
  },
  // 这个要写这里，写setup的onMounted会让map永远为null
  mounted() {
    this.map = getMap(this.box, {
      center: this.mapCenter,
      zoom: this.mapZoom,
      attribution: false,
    })
    this.map.on('viewchange', () => {
      const mapView = this.map.getView()
      const { center, zoom } = mapView as { center: number[]; zoom: number }
      this.$store.commit('setMapSite', {
        center,
        zoom,
      })
    })
    this.$nextTick(() => {
      if (this.cacheNetworkpoint?.guid) {
        this.onSwitchPoint(this.cacheNetworkpoint)
      }
    })
  },
  beforeUnmount() {
    this.clearLayer()
    this.removeLayer()
    if (this.map) this.map.remove()
  },
  methods: {
    onRightClick() {
      if (!this.cacheFaultBill?.id) {
        Toast('缺少报修单')
        return
      }
      const obj: CacheFaultBill = copy(this.cacheFaultBill)
      Object.assign(obj, {
        networkpoint: this._selectedItem,
      })
      this.$store.commit('setFaultBill', obj)
      this.$router.replace({ name: 'fault-form' })
    },
    clearLayer(): void {
      if (this._layer) this._layer.clear()
    },
    removeLayer(): void {
      if (this._layer) {
        this._layer.remove()
        this._layer = null
      }
    },
    onSwitchPoint(item: NetworkpointItem): void {
      this._selectedItem = item
      this.rightCanClick = !!item
      this.createLayer()
      this.clearLayer()
      const obj: DrawElement = {
        lat: item.lat,
        lng: item.lng,
        name: item.name,
      }
      this.drawSite(obj)
    },
    createLayer(): void {
      if (!this._layer && this.map)
        this._layer = new VectorLayer(Date.now().toString()).addTo(this.map)
    },
    drawSite(item: DrawElement): void {
      if (!this._layer || !this.map) return
      const { lat, lng, name } = item
      const point: number[] = [lng, lat]
      const marker: Marker = new Marker(point, {
        id: Date.now().toString(),
        editable: false,
        interactive: false,
        symbol: {
          markerFile: '/images/icon_weizhi.png',
          markerWidth: 40,
          markerHeight: 40,
          scale: 1,
          textName: name,
          textFill: 'rgba(255,255,255,1)',
          textSize: 12,
          textWeight: 500,
          textHaloFill: '#222',
          textHaloRadius: 1,
          textHaloOpacity: 0.6,
        },
      })
      this._layer.addGeometry(marker)
      this.map.setCenter(new Coordinate(point))
    },
  },
})
